// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page_Y6OXf{width:100%}.page__body_kRuP\\+{padding:16px}.seller_55owB{width:100% !important;margin-bottom:24px}.tags_yqH0H{display:flex;flex-wrap:wrap}.tag_S1heb{padding:8px 12px;background:#2b3848;color:#fff;border-radius:8px;font-size:14px;font-weight:500;line-height:18px;margin-right:8px;margin-bottom:8px;border:1px solid #2b3848;cursor:pointer}.tag_S1heb:last-child{margin-right:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": "page_Y6OXf",
	"page__body": "page__body_kRuP+",
	"seller": "seller_55owB",
	"tags": "tags_yqH0H",
	"tag": "tag_S1heb"
};
module.exports = ___CSS_LOADER_EXPORT___;
